export default "__VITE_ASSET__2f8d2264__"